import { Injectable } from '@angular/core';

// RxJS
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Services
import { MatDialog } from '@angular/material/dialog';

// Components
import { AlertComponent } from '../components/alert/alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  /**
   * Constructor
   */

  constructor(
    public dialog: MatDialog,
  ) { }

  /**
   * Methods
   */
  
  show(message: string | null = null, detail: string | null = null, buttons: string[] = ['Cancel', 'OK'], defaultButton: number | null = null): Observable<number> {
    return this.dialog
      .open(AlertComponent, { data: {message, detail, buttons, defaultButton}})
      .afterClosed()
      .pipe(
        map(result => {
          return result;
        })
      );
  }

}
